"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classNames = exports.cna = exports.cns = exports.cn = void 0;
var prf = function (className, prefix) {
  if (prefix === void 0) {
    prefix = 'shp--';
  }
  return "".concat(prefix).concat(className.replace(new RegExp("^".concat(prefix), 'i'), ''));
};
var cn = function (friendlyClassName, propClassName, prefix) {
  if (propClassName === void 0) {
    propClassName = '';
  }
  if (prefix === void 0) {
    prefix = 'shp--';
  }
  return "".concat(prf(friendlyClassName, prefix)).concat(propClassName ? " ".concat(propClassName) : '');
};
exports.cn = cn;
var cns = function (friendlyClassName, subComponent, prefix) {
  if (prefix === void 0) {
    prefix = 'shp--';
  }
  return "".concat(prf(friendlyClassName, prefix)).concat(subComponent ? "__".concat(subComponent) : '');
};
exports.cns = cns;
var cna = function (friendlyClassName, subComponent, prefix) {
  if (prefix === void 0) {
    prefix = 'shp--';
  }
  return {
    className: (0, exports.cns)(friendlyClassName, subComponent, prefix)
  };
};
exports.cna = cna;
var classNames = function (friendlyClassName, prefix) {
  if (prefix === void 0) {
    prefix = 'shp--';
  }
  return {
    invertedColor: function (subComponent) {
      return "inverted-".concat(friendlyClassName).concat(subComponent ? "-".concat(subComponent) : '');
    },
    color: function (subComponent) {
      return "".concat(friendlyClassName).concat(subComponent ? "-".concat(subComponent) : '');
    },
    attr: function (subComponent) {
      return (0, exports.cna)(friendlyClassName, subComponent, prefix);
    },
    sub: function (subComponent) {
      return (0, exports.cns)(friendlyClassName, subComponent, prefix);
    },
    name: function (propClassName) {
      return (0, exports.cn)(friendlyClassName, propClassName, prefix);
    },
    child: function (subComponent) {
      return ".".concat((0, exports.cns)(friendlyClassName, subComponent, prefix));
    },
    dot: function (subComponent) {
      return ".".concat((0, exports.cns)(friendlyClassName, subComponent, prefix));
    },
    rule: function (subComponent) {
      return ".".concat((0, exports.cns)(friendlyClassName, subComponent, prefix));
    },
    prf: prf
  };
};
exports.classNames = classNames;